import { useEffect } from 'react';
import {
	discardActiveSiteVisitRecording,
	finalizeSiteVisitRecording,
} from '@services/siteVisitRecording/siteVisitRecordingEngine';
import { uploadPendingSiteVisitRecording } from '@services/siteVisitRecording/uploadPendingSiteVisitRecording';
import { isSiteVisitRecordingActive, useSiteVisitRecordingStore } from '@store/siteVisitRecordingStore';
import { useSiteVisitRecordingUploadStore } from '@store/siteVisitRecordingUploadStore';
import useSiteLeadStore from '@store/siteLeadStore';

/**
 * Visit Recorded page: end any lingering visit-form / draft recording so BDE Feedback can start fresh.
 * Uploads only when this visit was started with recording consent; otherwise discards local data.
 */
export function useFinalizeVisitFormRecordingOnSuccessPage(): void {
	useEffect(() => {
		void (async (): Promise<void> => {
			const { phase, uploadOnStop } = useSiteVisitRecordingStore.getState();
			const hasConsent = useSiteLeadStore.getState().hasVisitRecordingConsent;

			if (!hasConsent) {
				await discardActiveSiteVisitRecording();
				return;
			}

			if (!isSiteVisitRecordingActive(phase) || uploadOnStop) {
				return;
			}

			await finalizeSiteVisitRecording(false);

			const pending = useSiteVisitRecordingUploadStore.getState().pending;
			if (!pending) {
				return;
			}

			try {
				await uploadPendingSiteVisitRecording(pending, true);
				useSiteVisitRecordingUploadStore.getState().clearPendingRecording();
			} catch {
				// keep pending for retry (error toast already shown)
			}
		})();
	}, []);
}
